import { useState, useEffect } from 'react';
import {
  OutlinedInput,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
} from '@material-ui/core';
import SearchOutlinedIcon from '@material-ui/icons/SearchOutlined';
import { TableContainer } from '@mui/material';
import { ReactComponent as DeleteIcon } from '../../../assets/ICONS/ic_round-delete-outline.svg';
import { RoutesFun } from '../../../schemas';
import { useHistory } from 'react-router-dom';
import { config as adminDashboardConfig } from '../AdminDashboard/config';
import { config as allOrgConfig, config } from './config';
import { ERRORS } from '../../../utils/constants';
import { capitalizeFirstLetter, handleError } from '../../../utils/config';
import CustomSwitch from '../AdminDashboard/components/CustomSwitch';
import SyncJobSwitch from '../AdminDashboard/components/SyncJobSwitch';
import './AllOrganizations.css';
import DeleteModal from '../../../components/Modals/DeleteModal/DeleteModal';
import { CustomModal } from '../../../components/Modals/CustomModal/CustomModal';
import { useDispatch } from 'react-redux';
import { userActions } from '../../../store/userSlice';
import TitleHeader from '../../../components/MasterComponent/TitleHeader/TitleHeader';
import { useFetchData } from '../../../hooks/useFetchData';
import { OverlayLoading } from '../../../components/Modals/OverlayLoading/OverlayLoading';

const AllOrganizations: React.FC = () => {
  const history = useHistory();
  const Routes = RoutesFun();
  const [loader, setLoader] = useState(false);
  const [companiesDetails, setCompaniesDetails] = useState([]);
  const [networkError, setNetworkError] = useState('');
  const [search, setSearch] = useState('');
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [clickedData, setClickedData] = useState<any>();
  const [updateAllModal, setUpdateAllModal] = useState<boolean>(false);
  const [updateAllStatus, setUpdateAllStatus] = useState<number | null>(null);
  const {
    fetch: updateAllOrganizations,
    loader: updateAllLoader,
  } = useFetchData({
    fetchData: (payload: any) => config.updateAllOrganisationStatus(payload),
    fetchOnMount: false,
  });

  const dispatch = useDispatch();
  const onCloseDeleteModal = () => setDeleteModal(false);

  const onCloseUpdateAllModal = () => {
    if (updateAllLoader) return;
    setUpdateAllModal(false);
    setUpdateAllStatus(null);
  };

  const handleSearchChange = (e: any) => {
    setSearch(e.target.value);
  };

  const fetchAllOrganizaionDetails = async () => {
    try {
      setLoader(true);
      const res = await adminDashboardConfig.fetchCompaniesData();
      res.sort((a: any, b: any) => a.name.localeCompare(b.name));
      if (res) setCompaniesDetails(res);
    } catch (e: any) {
      setNetworkError(e === ERRORS.NETWORK_ERROR ? e : '');
      if (e && e.error && e.error.message) {
        handleError(e, history);
      }
    } finally {
      setLoader(false);
    }
  };

  const deleteOrganization = async () => {
    try {
      const res = await allOrgConfig.deleteOrganization({
        CompanyName: clickedData.CompanyName,
      });
      if (res.sc) {
        setCompaniesDetails((preValue: any) =>
          preValue.filter(
            (company: any) => company.name !== clickedData.CompanyName
          )
        );

        dispatch(
          userActions.replaceUserState({
            successMessage: res,
          })
        );
      }
    } catch (e: any) {
      setNetworkError(e === ERRORS.NETWORK_ERROR ? e : '');
      if (e && e.error && e.error.message) {
        handleError(e, history);
      }
    } finally {
      setDeleteModal(false);
    }
  };

  const handleUpdateAllOrganizations = async () => {
    try {
      await updateAllOrganizations({ IsActive: updateAllStatus });
    } catch (e: any) {
      setNetworkError(e === ERRORS.NETWORK_ERROR ? e : '');
      if (e && e.error && e.error.message) {
        handleError(e, history);
      }
    } finally {
      onCloseUpdateAllModal();
      fetchAllOrganizaionDetails();
    }
  };

  const openUpdateAllModal = (status: number) => {
    setUpdateAllStatus(status);
    setUpdateAllModal(true);
  };

  const returnSearchResult = (data: any) =>
    search
      ? data?.filter((org: any) =>
          org.name?.toLowerCase().includes(search.toLowerCase())
        )
      : data;

  useEffect(() => {
    fetchAllOrganizaionDetails();
  }, []);

  return (
    <>
      <div className="organizationDetails">
        <div className="OrgDetails-uppterStrip">
          <TitleHeader
            extraContent={
              <div
                style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}
              >
                <div className="OrgDetails-us-searchBar">
                  <OutlinedInput
                    id="email"
                    name="EmailAddress"
                    className="outlineInputArea bgcolor"
                    type="email"
                    autoComplete="off"
                    value={search ? search : ''}
                    onChange={handleSearchChange}
                    placeholder="Search..."
                    endAdornment={
                      <InputAdornment position="end">
                        <SearchOutlinedIcon />
                      </InputAdornment>
                    }
                  />
                </div>
                <div style={{ display: 'flex', gap: '0.5rem' }}>
                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: '#4caf50',
                      color: 'white',
                      textTransform: 'none',
                      fontSize: '13px',
                      padding: '6px 16px',
                    }}
                    onClick={() => openUpdateAllModal(1)}
                  >
                    Activate All
                  </Button>
                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: '#f44336',
                      color: 'white',
                      textTransform: 'none',
                      fontSize: '13px',
                      padding: '6px 16px',
                    }}
                    onClick={() => openUpdateAllModal(0)}
                  >
                    Deactivate All
                  </Button>
                </div>
              </div>
            }
          >
            All Organization
          </TitleHeader>
        </div>
        <TableContainer
          sx={{ maxHeight: '74vh', overflowY: 'auto' }}
          className="accContainer"
        >
          <Table
            className="table adminTable OrgTable"
            size="small"
            aria-label="a dense table"
            stickyHeader
          >
            <TableHead className="admintableHead">
              <TableRow>
                <TableCell
                  className="adminTableheading"
                  align="right"
                  width="8%"
                >
                  S.No.
                </TableCell>
                <TableCell className="adminTableheading" width={'30%'}>
                  Organization Name
                </TableCell>
                <TableCell className="adminTableheading" width={'30%'}>
                  Plan Name
                </TableCell>
                <TableCell className="adminTableheading" width={'30%'}>
                  Plan Cost
                </TableCell>
                <TableCell className="adminTableheading" width={'30%'}>
                  Remaining Days
                </TableCell>
                <TableCell className="adminTableheading" width={'30%'}>
                  Plan Status
                </TableCell>
                <TableCell className="adminTableheading" width={'30%'}>
                  Accounts/Subscriptions
                </TableCell>
                <TableCell className="adminTableheading" width={'30%'}>
                  Total Accounts
                </TableCell>
                <TableCell className="adminTableheading" width={'20%'}>
                  Status
                </TableCell>
                <TableCell className="adminTableheading" width={'20%'}>
                  Sync Job
                </TableCell>
                <TableCell className="adminTableheading" width={'25%'}>
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loader ? (
                <TableRow>
                  <TableCell
                    colSpan={11}
                    align="center"
                    className="loadingSection"
                  >
                    Loading...
                  </TableCell>
                </TableRow>
              ) : companiesDetails?.length &&
                search &&
                !returnSearchResult(companiesDetails).length ? (
                <TableRow>
                  <TableCell
                    colSpan={11}
                    align="center"
                    className="loadingSection"
                  >
                    No Searched Records
                  </TableCell>
                </TableRow>
              ) : companiesDetails?.length ||
                returnSearchResult(companiesDetails).length ? (
                returnSearchResult(companiesDetails).map(
                  (organization: any, i: number) => (
                    <TableRow
                      key={i}
                      className={i % 2 === 0 ? 'oddRow' : 'evenRow'}
                    >
                      <TableCell>{i + 1}</TableCell>
                      <TableCell>
                        <span
                          className="upperCase clickble"
                          onClick={() =>
                            history.push({
                              pathname: Routes.Organization,
                              state: {
                                CompanyName: organization.name,
                              },
                            })
                          }
                        >
                          {organization.name}
                        </span>
                      </TableCell>
                      <TableCell>
                        {organization.planName ? (
                          <p className="font-14px fw-600">
                            {organization.planName}
                          </p>
                        ) : (
                          'No Active Plan'
                        )}
                      </TableCell>
                      <TableCell>
                        {organization.planCost ? (
                          <p className="font-14px fw-600">
                            ${organization.planCost / 100}
                          </p>
                        ) : (
                          'N/A'
                        )}
                      </TableCell>
                      <TableCell>
                        {organization.status === 'expired'
                          ? 'NA'
                          : organization.planDaysRemaining}
                      </TableCell>
                      <TableCell>
                        {organization.status === 'expired' ? (
                          <p
                            className="font-14px"
                            style={{ color: 'red', fontWeight: 500 }}
                          >
                            {capitalizeFirstLetter(organization.status)}
                          </p>
                        ) : (
                          <p
                            className="font-14px"
                            style={{ color: 'green', fontWeight: 500 }}
                          >
                            {capitalizeFirstLetter(organization.status)}
                          </p>
                        )}
                      </TableCell>
                      <TableCell>
                        {organization.cloudProviders.join(', ')}
                      </TableCell>
                      <TableCell>{organization.totalAccounts}</TableCell>
                      <TableCell>
                        <div
                          className={
                            organization.IsActive === 1 ? 'active' : 'inactive'
                          }
                        >
                          {organization.IsActive ? 'Active' : 'Inactive'}
                        </div>
                      </TableCell>
                      <TableCell>
                        <SyncJobSwitch
                          isSyncJobEnabled={organization.IsSyncJobEnabled || 0}
                          companyName={organization.name}
                          fetchLatestData={fetchAllOrganizaionDetails}
                        />
                      </TableCell>
                      <TableCell className="d-flex space-between align-center">
                        <span>
                          <CustomSwitch
                            status={organization.IsActive}
                            metaData={{
                              CompanyName: organization.name,
                            }}
                            fetchLatestData={fetchAllOrganizaionDetails}
                          />
                        </span>

                        <DeleteIcon
                          onClick={() => {
                            setDeleteModal(true);
                            setClickedData({
                              CompanyName: organization.name,
                            });
                          }}
                          className="ml-10 cursor"
                        />
                      </TableCell>
                    </TableRow>
                  )
                )
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={11}
                    align="center"
                    className="loadingSection"
                  >
                    No Records Found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      {deleteModal && (
        <DeleteModal
          show={deleteModal}
          onClose={onCloseDeleteModal}
          metaData={`"${clickedData.CompanyName}"`}
          deleteFunction={deleteOrganization}
        />
      )}

      {updateAllModal && (
        <CustomModal
          show={updateAllModal}
          onClose={onCloseUpdateAllModal}
          submitFunc={handleUpdateAllOrganizations}
          buttonMsg={
            updateAllLoader
              ? 'Processing...'
              : updateAllStatus === 1
              ? 'Activate All'
              : 'Deactivate All'
          }
          headerMsg={`${
            updateAllStatus === 1 ? 'Activate' : 'Deactivate'
          } All Organizations`}
          isSubmitBtnDisabled={updateAllLoader}
          requireConfirmation={true}
          confirmationMsg={`I understand that this will ${
            updateAllStatus === 1 ? 'activate' : 'deactivate'
          } ALL organizations and their users. This action will affect the entire system.`}
        >
          <div style={{ padding: '1rem 0' }}>
            {updateAllLoader && <OverlayLoading />}
            <p
              style={{
                marginBottom: '1rem',
                fontSize: '15px',
                fontWeight: 500,
              }}
            >
              ⚠️ Warning: This is a critical operation
            </p>
            <p
              style={{
                marginBottom: '0.5rem',
                fontSize: '14px',
                lineHeight: '1.6',
              }}
            >
              You are about to{' '}
              <strong
                style={{ color: updateAllStatus === 1 ? '#4caf50' : '#f44336' }}
              >
                {updateAllStatus === 1 ? 'ACTIVATE' : 'DEACTIVATE'}
              </strong>{' '}
              all organizations in the system.
            </p>
            <ul
              style={{
                paddingLeft: '1.5rem',
                marginTop: '1rem',
                fontSize: '14px',
                lineHeight: '1.8',
              }}
            >
              <li>
                This will affect <strong>{companiesDetails.length}</strong>{' '}
                organization(s)
              </li>
              {updateAllStatus === 1 ? (
                <>
                  <li>All organizations will be set to Active status</li>
                  <li>Users with RoleId = 2 will be activated and verified</li>
                </>
              ) : (
                <>
                  <li>All organizations will be set to Inactive status</li>
                  <li>
                    Users with RoleId = 2 will be deactivated and unverified
                  </li>
                  <li>Other users will be unverified but remain active</li>
                </>
              )}
            </ul>
            <p
              style={{
                marginTop: '1.5rem',
                fontSize: '13px',
                color: '#666',
                fontStyle: 'italic',
              }}
            >
              Please confirm that you understand the consequences before
              proceeding.
            </p>
          </div>
        </CustomModal>
      )}
    </>
  );
};

export default AllOrganizations;
